export const userPersonalInfoGetApi = (data) => {    
    return data.data;
}
export const personalDetailsUpdateApi = (data) => {    
    return data.data;
}